const PREFIX = "incognito-cart";

export const INCOGNITO_CART_DATA_TEST_IDS = {
    HALF_CARD: {
        CONTAINER: `${PREFIX}-half-card-container`,
        PRIVATE_ORDER_IMAGE: `${PREFIX}-half-card-private-order-image`,
        PRIVATE_ORDER_TEXT: `${PREFIX}-half-card-private-order-text`,
        BENEFITS_WRAPPER: `${PREFIX}-half-card-benefits-wrapper`,
        PRIVATE_ORDER_BUTTON: `${PREFIX}-half-card-private-order-button`,
    },
    LOTTIE_CONTAINER: `${PREFIX}-lottie-container`,
    LOTTIE_ANIMATION: `${PREFIX}-lottie-animation`,
    TOOL_TIP: {
        CONTAINER: `${PREFIX}-tooltip-container`,
        TEXT: `${PREFIX}-tooltip-text`,
        CLOSE_BUTTON: `${PREFIX}-tooltip-close-button`,
    },
    TOP_BANNER: {
        CONTAINER: `${PREFIX}-top-banner-container`,
        TEXT: `${PREFIX}-top-banner-text`,
    },
};
